import { BillingDetail } from "./billing-detail";
import { CompanyAddress } from "./company-address";
import { CompanyGst } from "./company-gst";
import { Office } from "./office";


export class CompanyProfile {
    companyId?: string;
    name?: string;
    billingCode?: string;
    gst?: CompanyGst;
    website?: string;
    address?: CompanyAddress;
    defaultCurrency?: string;
    billingDetail?: BillingDetail;
    offices?: Office[];
    documentIds?: string[];
}
